import type { LitElement } from "lit";
import type { BarButtonPort } from "./BarButtonPort";

/** The state of one bar button, rendered by the bar's template; every write asks the bar to re-render. */
export class BarButton implements BarButtonPort {
  public shown: boolean;
  public enabled = true;
  public onTap: (() => void) | null = null;

  public constructor(
    private readonly host: LitElement,
    shown: boolean,
  ) {
    this.shown = shown;
  }

  public setShown(shown: boolean): void {
    this.shown = shown;
    this.host.requestUpdate();
  }

  public setInteractable(interactable: boolean): void {
    this.enabled = interactable;
    this.host.requestUpdate();
  }

  public setOnTap(onTap: (() => void) | null): void {
    this.onTap = onTap;
  }

  public tap(): void {
    if (this.enabled) this.onTap?.();
  }
}
